module.exports = __webpack_public_path__ + "img/play-circle-solid.72085fe6.svg";